// extracted by mini-css-extract-plugin
export default {"submit-button":"Button_submit-button__8hgql"};